import axios from "axios";
import {
  ClientFileSummariesResponse,
  ClientFilesPage,
  FileBlobResponse,
} from "../types";
import config from "../../../config";

const apiUrl = config.api;

export const getClientFileSummaries =
  async (): Promise<ClientFileSummariesResponse> => {
    const response = await axios.get<ClientFileSummariesResponse>(
      `${apiUrl}/file-monitor/clients`,
    );
    return response.data;
  };

// Gets one page of a client's files, newest first.
export const getClientFilesPage = async (
  clientId: number,
  skip: number,
): Promise<ClientFilesPage> => {
  const response = await axios.get<ClientFilesPage>(
    `${apiUrl}/file-monitor/clients/${clientId}`,
    { params: skip > 0 ? { skip } : undefined },
  );
  return response.data;
};

export const getFileBlob = async (
  fileId: number,
): Promise<FileBlobResponse> => {
  const response = await axios.get<FileBlobResponse>(
    `${apiUrl}/files/${fileId}/blob`,
  );
  return response.data;
};

export const reprocessFile = async (fileId: number): Promise<void> => {
  await axios.post(`${apiUrl}/files/${fileId}/reprocess`);
};

export const deleteFile = async (fileId: number): Promise<void> => {
  await axios.delete(`${apiUrl}/files/${fileId}`);
};
